import { useTranslations } from 'next-intl';
import { BodyStrong, Button, MetaDefault } from '@terra/ui-design-system';
import { VStack } from '@terra/ui-styled-system';

type LauncherNoMatchesProps = {
  query: string;
  tenantName?: string;
  onSearchAnotherTenant?: () => void;
};

export function LauncherNoMatches({
  query,
  tenantName,
  onSearchAnotherTenant,
}: LauncherNoMatchesProps) {
  const t = useTranslations('proxy.workspaces');

  return (
    <VStack gap="4" py="10" alignItems="center" textAlign="center">
      <VStack gap="1" alignItems="center">
        <BodyStrong data-bi-unmask="true">
          {tenantName
            ? t('noTargetsMatch', { query: query.trim(), tenantName })
            : t('noTargetsMatchQuery', { query: query.trim() })}
        </BodyStrong>
        {onSearchAnotherTenant && (
          <MetaDefault color="fg.neutral.muted">
            {t('targetMayBeInAnotherTenant')}
          </MetaDefault>
        )}
      </VStack>
      {onSearchAnotherTenant && (
        <Button variant="outline" size="sm" onClick={onSearchAnotherTenant}>
          {t('searchInAnotherTenant')}
        </Button>
      )}
    </VStack>
  );
}
